import { onMounted, watch } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useNotificationsHubStore } from 'dashboard/stores/notificationsHub';

// Reminders now fire server-side (Dotchat::TriggerDueRemindersJob) and Hub
// notifications arrive over ActionCable. This composable just bootstraps the
// Notifications Hub for the logged-in user: tracks who they are (so the browser
// alert can be gated) and loads the existing log once on mount.
export const useReminderScheduler = () => {
  const store = useNotificationsHubStore();
  const currentUser = useMapGetter('getCurrentUser');

  const bootstrap = () => {
    if (!currentUser.value?.id) return;
    store.setCurrentUser(currentUser.value.id);
    store.fetch().catch(() => {});
  };

  onMounted(bootstrap);
  watch(() => currentUser.value?.id, bootstrap);
};
